<p-floatLabel>
  <p-select #questionGroupStateDropdown
            id="questionGroupStateDropdown"
            name="questionGroupStateDropdown"
            [options]="questionGroupStates"
            [(ngModel)]="questionGroupState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="questionGroupStateDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
